import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { Provider, useDispatch, useSelector } from "react-redux";
import store from "./store/store";
import axios from "axios";
import { setDomains } from "./store/slice";
import { BASE_URL } from "./Service";


const root = ReactDOM.createRoot(document.getElementById("root"));
const urlParams = new URLSearchParams(window.location.search);
const host = urlParams.get("host") || window.location.hostname;
console.log("hostame", host);

const Loader = () => (
  <div style={{
    height: '100vh',
    width: '100vw',
    overflow: 'hidden',
    position: 'fixed',
    left: 0,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#ffffff',
    zIndex: 9999
  }}>
    <div className="loader" />
    <style>
      {`
       .loader {
  color: #03228f;
  font-size: 10px;
  width: 1em;
  height: 1em;
  border-radius: 50%;
  position: relative;
  text-indent: -9999em;
  animation: mulShdSpin 1.3s infinite linear;
  transform: translateZ(0);
}

@keyframes mulShdSpin {
  0%,
  100% {
    box-shadow: 0 -3em 0 0.2em, 
    2em -2em 0 0em, 3em 0 0 -1em, 
    2em 2em 0 -1em, 0 3em 0 -1em, 
    -2em 2em 0 -1em, -3em 0 0 -1em, 
    -2em -2em 0 0;
  }
  12.5% {
    box-shadow: 0 -3em 0 0, 2em -2em 0 0.2em, 
    3em 0 0 0, 2em 2em 0 -1em, 0 3em 0 -1em, 
    -2em 2em 0 -1em, -3em 0 0 -1em, 
    -2em -2em 0 -1em;
  }
  25% {
    box-shadow: 0 -3em 0 -0.5em, 
    2em -2em 0 0, 3em 0 0 0.2em, 
    2em 2em 0 0, 0 3em 0 -1em, 
    -2em 2em 0 -1em, -3em 0 0 -1em, 
    -2em -2em 0 -1em;
  }
  37.5% {
    box-shadow: 0 -3em 0 -1em, 2em -2em 0 -1em,
     3em 0em 0 0, 2em 2em 0 0.2em, 0 3em 0 0em, 
     -2em 2em 0 -1em, -3em 0em 0 -1em, -2em -2em 0 -1em;
  }
  50% {
    box-shadow: 0 -3em 0 -1em, 2em -2em 0 -1em,
     3em 0 0 -1em, 2em 2em 0 0em, 0 3em 0 0.2em, 
     -2em 2em 0 0, -3em 0em 0 -1em, -2em -2em 0 -1em;
  }
  62.5% {
    box-shadow: 0 -3em 0 -1em, 2em -2em 0 -1em,
     3em 0 0 -1em, 2em 2em 0 -1em, 0 3em 0 0, 
     -2em 2em 0 0.2em, -3em 0 0 0, -2em -2em 0 -1em;
  }
  75% {
    box-shadow: 0em -3em 0 -1em, 2em -2em 0 -1em, 
    3em 0em 0 -1em, 2em 2em 0 -1em, 0 3em 0 -1em, 
    -2em 2em 0 0, -3em 0em 0 0.2em, -2em -2em 0 0;
  }
  87.5% {
    box-shadow: 0em -3em 0 0, 2em -2em 0 -1em, 
    3em 0 0 -1em, 2em 2em 0 -1em, 0 3em 0 -1em, 
    -2em 2em 0 0, -3em 0em 0 0, -2em -2em 0 0.2em;
  }
}
  
      `}
    </style>
  </div>
);

function AppWrapper() {
  const [AppComponent, setAppComponent] = useState(null);
  const dispatch = useDispatch();
  const domains = useSelector((state) => state.data.domains);
  const [loading, setLoading] = useState(true);



  const appLoaders = {
    theme1: async () => {
      const { default: App } = await import("./theme-1/src/app/App");
      await import("./theme-1/src/assets/scss/App.scss");
      document.body.classList.add("theme1-font");
      return App;
    },
    theme2: async () => {
      const { default: App } = await import("./theme-2/src/app/App");
      await import("./theme-2/src/assets/scss/App.scss");
      document.body.classList.add("theme2-font");
      return App;
    },
    theme3: async () => {
      const { default: App } = await import("./theme-3/src/App");
      await import("./theme-3/public/scss/main.scss");
      return App;
    },
  };

  useEffect(() => {
    const fetchDomains = async () => {
      try {
        const res = await axios.get(`${BASE_URL}/api/v1/site/getDomains`);
        if (res.data.success) {
          dispatch(setDomains(res.data.data));
        }
      } catch (error) {
        console.error("Error fetching domains:", error);
      }
    };

    fetchDomains();
  }, [dispatch]);

  useEffect(() => {
    const matched = domains.find(site =>
      site.domainList.includes(host)
    );

    const loadApp = async () => {
      // if (matched && appLoaders[matched.name]) {
      if (matched && matched.appliedTheme && appLoaders[matched.appliedTheme]) {

        // const App = await appLoaders[matched.name]();
        const App = await appLoaders[matched.appliedTheme]();

        setAppComponent(() => App);
      } else {
        alert("No matching domain");
      }
      setLoading(false);
    };

    if (domains.length > 0) {
      loadApp();
    }
  }, [domains, host]);

  if (loading || !AppComponent) return <Loader />;

  return <AppComponent />;
}

root.render(
  <BrowserRouter>
    <Provider store={store}>
      <AppWrapper />
    </Provider>
  </BrowserRouter>
);







// import React, { useEffect, useState } from "react";
// import ReactDOM from "react-dom/client";
// import { BrowserRouter } from "react-router-dom";
// import { Provider } from "react-redux";
// import store from "./store/store";

// const root = ReactDOM.createRoot(document.getElementById("root"));
// const urlParams = new URLSearchParams(window.location.search);
// const host = urlParams.get("host") || window.location.hostname;
// console.log("hostame", host);

// function AppWrapper() {
//   const [AppComponent, setAppComponent] = useState(null);

//   useEffect(() => {
//     const loadApp = async () => {
//       document.body.classList.remove("theme1-font", "theme2-font");
//       // For Techniajz site---->
//       if (host === "techniajz.com") {
//         const { default: TechniajzApp } = await import(
//           "./techniajz/src/app/App"
//         );
//         await import("./techniajz/src/assets/scss/App.scss");
//         // await import("bootstrap/dist/css/bootstrap.min.css");
//         document.body.classList.add("theme1-font");
//         setAppComponent(() => TechniajzApp);
//       }
//       // For Algoza site---->
//       else if (
//         host === "algozatechnologies.com" ||
//         host === "www.algozatechnologies.com"
//       ) {
//         const { default: AlgozaApp } = await import("./algoza/src/app/App");
//         await import("./algoza/src/assets/scss/App.scss");
//         // await import("bootstrap/dist/css/bootstrap.min.css");
//         document.body.classList.add("theme2-font");
//         setAppComponent(() => AlgozaApp);
//       }
//       // For UpMyTeam site--->
//       else if (host === "upmyteam.com") {
//         const { default: UpMyTeam } = await import("./upmyteam/src/App");
//                 await import("./upmyteam/public/scss/main.scss");

//         // await import("./upmyteam/src/App.css");
//         // await import("react-toastify/dist/ReactToastify.css");

//         setAppComponent(() => UpMyTeam);
//       }
//     };

//     loadApp();
//   }, []);

//   // Prevent rendering until styles and app are ready
//   if (!AppComponent) return null;

//   return <AppComponent />;
// }

// root.render(
//   <BrowserRouter>
//     <Provider store={store}>
//       <AppWrapper />
//     </Provider>
//   </BrowserRouter>
// );

// import React from "react";
// import ReactDOM from "react-dom/client";
// import TechniajzApp from "./techniajz/src/app/App";
// import AlgozaApp from "./algoza/src/app/App";
// import UpMyTeam from "./upmyteam/src/App";
// import { BrowserRouter } from "react-router-dom";
// import { Provider } from "react-redux";
// import store from "./store/store";

// const root = ReactDOM.createRoot(document.getElementById("root"));
// const host = window.location.hostname;

// if (host === "techniajz.com") {
//   import("./techniajz/src/assets/scss/App.scss");
//   import("bootstrap/dist/css/bootstrap.min.css");
// } else if (host === "algoza.com" || host === "localhost") {
//   import("./algoza/src/assets/scss/App.scss");
//   import("bootstrap/dist/css/bootstrap.min.css");
// } else if (host === "upmyteam.com") {
//   import("./upmyteam/src/App.css");
// }

// function getApp(host) {
//   if (host === "techniajz.com") {
//     document.body.classList.remove("theme2-font");
//     document.body.classList.add("theme1-font");
//     return <TechniajzApp />;
//   } else if (host === "algoza.com" || host === "localhost") {
//     document.body.classList.remove("theme1-font");
//     document.body.classList.add("theme2-font");
//     return <AlgozaApp />;
//   } else if (host === "upmyteam.com") {
//     return <UpMyTeam />;
//   }
// }
// root.render(
//   <BrowserRouter basename="/">
//     <Provider store={store}>{getApp(host)}</Provider>
//   </BrowserRouter>
// );

// import React, { useEffect, useState } from "react";
// import ReactDOM from "react-dom/client";
// import { BrowserRouter } from "react-router-dom";
// import { Provider } from "react-redux";
// import store from "./store/store";

// const root = ReactDOM.createRoot(document.getElementById("root"));
// const host = window.location.hostname;

// function AppWrapper() {
//   const [AppComponent, setAppComponent] = useState(null);

//   useEffect(() => {
//     const loadApp = async () => {
//       // Clear any previous theme class
//       // document.body.classList.remove("theme1-font", "theme2-font");

//       if (host === "techniajz.com") {
//         const { default: TechniajzApp } = await import(
//           "./techniajz/src/app/App"
//         );
//         await import("./techniajz/src/assets/scss/App.scss");
//         await import("bootstrap/dist/css/bootstrap.min.css");
//         document.body.style.fontFamily =
//           '"Calibri", "Trebuchet MS", sans-serif';
//         setAppComponent(() => TechniajzApp);
//       } else if (host === "algoza.com") {
//         const { default: AlgozaApp } = await import("./algoza/src/app/App");
//         await import("./algoza/src/assets/scss/App.scss");
//         await import("bootstrap/dist/css/bootstrap.min.css");
//         document.body.style.fontFamily = "Livvic, sans-serif";
//       } else if (host === "upmyteam.com" || host === "localhost") {
//         const { default: UpMyTeam } = await import("./upmyteam/src/App");
//         await import("react-toastify/dist/ReactToastify.css");
//         await import("./upmyteam/src/App.css"); // Tailwind styles
//         setAppComponent(() => UpMyTeam);
//       }
//     };

//     loadApp();
//   }, []);

//   if (!AppComponent) return null;

//   return <AppComponent />;
// }

// root.render(
//   <BrowserRouter>
//     <Provider store={store}>
//       <AppWrapper />
//     </Provider>
//   </BrowserRouter>
// );
